import { render, staticRenderFns } from "./hotWords.vue?vue&type=template&id=2ea5f2d4"
import script from "./hotWords.vue?vue&type=script&lang=js"
export * from "./hotWords.vue?vue&type=script&lang=js"
import style0 from "./hotWords.vue?vue&type=style&index=0&id=2ea5f2d4&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ea5f2d4')) {
      api.createRecord('2ea5f2d4', component.options)
    } else {
      api.reload('2ea5f2d4', component.options)
    }
    module.hot.accept("./hotWords.vue?vue&type=template&id=2ea5f2d4", function () {
      api.rerender('2ea5f2d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/systemsettings/hotwords/hotWords.vue"
export default component.exports